<template>
  <div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">List name</label>
          <b-form-input
              type="text"
              :state="informationValidation.isPersonalListNameProvided"
              v-model="currentToDoListName"></b-form-input>

          <b-form-invalid-feedback v-if="!informationValidation.isPersonalListNameProvided">
            This field must not be empty.
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">List description</label>
          <b-form-input
              type="text"
              v-model="currentToDoListDescription"></b-form-input>
        </b-col>
      </b-row>
    </div>
    <hr>
    <b-button class="main-input-button" block @click="updateListDetails">Update list details</b-button>
  </div>
</template>

<script>
  import {db} from "../../../main";
  import {required} from "vuelidate/lib/validators";

  export default {
    name: "TaskListEditListDetails",
    data() {
      return {
        toDoListId: null,
        toDoListDetails: {},
        currentToDoListName: '',
        currentToDoListDescription: '',
        informationValidation: {
          isPersonalListNameProvided: null
        }
      }
    },
    validations: {
      currentToDoListName: {
        required
      }
    },
    methods: {
      // editListDetails() {
      //   this.hideModal('task-list-option-modal')
      // },
      hideModal(id) {
        this.$root.$emit('bv::hide::modal', id)
      },
      updateListDetails() {
        // check if all information is valid
        let isValid = true

        if (!this.$v.currentToDoListName.required) {
          this.informationValidation.isPersonalListNameProvided = false
          isValid = false
        } else {
          this.informationValidation.isPersonalListNameProvided = true
        }

        if (isValid) {
          db
            .collection('personal_to_do_lists')
            .doc(this.toDoListId)
            .update({
              toDoListName: this.currentToDoListName,
              toDoListDescription: this.currentToDoListDescription
            })
            .then(() => {
              this.hideModal('task-list-option-modal')
            })
        }
      }
    },
    mounted() {
      this.toDoListId = this.$route.params.personalListId

      db.collection('personal_to_do_lists')
        .doc(this.toDoListId)
        .onSnapshot(doc => {
          this.toDoListDetails = doc.data()
          this.currentToDoListName = this.toDoListDetails.toDoListName
          this.currentToDoListDescription = this.toDoListDetails.toDoListDescription
        })
    }
  }
</script>

<style scoped>
  .input-container {
    margin-bottom: 1em;
  }

  .input-title {
    font-weight: bold;
  }

  .main-input-button {
    font-weight: bold;
    background-color: #212441;
    padding: 0.5em;
  }

  .main-input-button:hover {
    font-weight: bold;
    background-color: #FFFFFF;
    color: #212441;
    padding: 0.5em;
  }
</style>
